var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('label',[_c('gmap-autocomplete',{on:{"place_changed":_vm.setPlace}}),_c('button',{on:{"click":_vm.addMarker}},[_vm._v(_vm._s(_vm.$t('add')))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }